export const DOCUMENTS_FILTER_FIELDS = [
  {
    type: 'text',
    name: 'name',
    label: 'Keywords',
    value: ''
  },
  {
    type: 'dropdown',
    name: 'file_family',
    label: 'All file types',
    value: '',
    options: [
      {
        text: 'Image',
        value: 'image'
      },
      {
        text: 'Document',
        value: 'application'
      },
      {
        text: 'Video',
        value: 'video'
      }
    ]
  },
  {
    type: 'dropdown_group',
    name: 'created_user_id',
    label: 'Uploaded by',
    value: '',
    apiUrl: 'groups/members/list'
  },
  {
    type: 'date',
    name: 'created_at',
    label: 'Created At',
    value: ''
  },
  {
    type: 'dropdown',
    name: 'date_match',
    label: 'Exact Date',
    value: '',
    options: [
      {
        text: 'Exact Date',
        value: 'exact'
      },
      {
        text: 'Before',
        value: 'before'
      },
      {
        text: 'On and Before',
        value: 'onandbefore'
      },
      {
        text: 'After',
        value: 'after'
      },
      {
        text: 'On and After',
        value: 'onandafter'
      },
    ]
  }
];
